import PropTypes from "prop-types";
import React from "react";
import Str from "shared/components/Str";
import isApp from "shared/util/isApp";
import { isIOS } from "shared/util/EnvironmentHelpers";
import AppPhoneCommand from "shared/util/AppPhoneCommand";


import { SCREENS } from "apps/login/util/constants";

class PasswordSubmit extends React.Component {
	static propTypes = {
		changeScreen: PropTypes.func.isRequired,
	};

	_backToLogin = () => {
		if (isApp() && isIOS) {
			AppPhoneCommand("popActivity");
		} else {
			this.props.changeScreen(SCREENS.LOGIN);
		}
	};

	render() {
		return (
			<span className="login-form">
				<div className="login-fields">
					<Str className="login-fields-text">
						Check your spam folder if it doesn’t arrive
					</Str>
				</div>

				<div className="login-actions login-footer">
					<button
						className="passwordsubmit-button login-actions-button"
						onClick={this._backToLogin}
					>
						<Str>Log in</Str>
					</button>
				</div>
			</span>
		);
	}
}

export default PasswordSubmit;



// WEBPACK FOOTER //
// ./src/apps/login/components/screens/PasswordSubmit.jsx